'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EPIC_END = exports.EPIC_END = '@@redux-observable/EPIC_END';


//////////////////
// WEBPACK FOOTER
// ./~/redux-observable/lib/EPIC_END.js
// module id = 645
// module chunks = 0